import * as events from './../node_modules/ol/events.js';
import * as condition from './../node_modules/ol/events/condition.js';

const merged = {
  ...events,
  condition
};

export default merged;
